import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2, AlertTriangle, Zap, ShieldCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PromoterVerify() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState("verifying");
  const [error, setError] = useState("");
  const didRun = useRef(false);

  useEffect(() => {
    if (didRun.current) return;
    didRun.current = true;
    axios.post(`${API}/promoter/auth/verify`, { token })
      .then(res => {
        localStorage.setItem("lf_promoter_session", res.data.session_token);
        setState("ok");
        setTimeout(() => navigate("/promoter/dashboard"), 500);
      })
      .catch(err => {
        setState("error");
        setError(err.response?.data?.detail || "Invalid or expired link");
      });
  }, [token, navigate]);

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center px-4" data-testid="promoter-verify-page">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto bg-zinc-950 rounded-xl flex items-center justify-center mb-4"><Zap size={20} className="text-white" /></div>
        {state === "verifying" && (
          <>
            <Loader2 size={24} className="animate-spin text-zinc-400 mx-auto mb-3" />
            <p className="text-sm text-zinc-600">Signing you in…</p>
          </>
        )}
        {state === "ok" && (
          <>
            <ShieldCheck size={28} className="text-emerald-600 mx-auto mb-3" />
            <p className="text-sm text-zinc-700">Welcome back — redirecting to your dashboard.</p>
          </>
        )}
        {state === "error" && (
          <div data-testid="promoter-verify-error">
            <AlertTriangle size={28} className="text-red-500 mx-auto mb-3" />
            <p className="text-sm text-zinc-700 mb-3">{error}</p>
            <button onClick={() => navigate("/promoter/login")} className="text-sm text-blue-600 underline">Request a new link</button>
          </div>
        )}
      </div>
    </div>
  );
}
